import { withLocalize } from 'react-localize-redux';
import { LanguageToggleComponent } from '../LanguageToggle.component';

export const LanguageToggle = withLocalize(LanguageToggleComponent);
